<script>

	import { State, ViewerState, getProjectId, startListeningForViewers, adjustOrderForFixedItems} from './store.js';
	import { PaywallJSState } from './paywall'
	import { allComponents, addDefaultStyle} from './PaywallComponents/components'
	import AppContainer from './Components/AppContainer.svelte';
	import ComponentEditor from './Components/ComponentEditor.svelte';
	import StateDebugger from './Components/StateDebugger.svelte';
	import PaywallContainer from './Components/PaywallContainer.svelte';
	import Button from './Components/Button.svelte'
	import Icon from './Components/Icon.svelte'
	import { v4 as uuidv4 } from 'uuid';
	import QrCode from "svelte-qrcode";
	import GlobalStyles from './globalStyles.js';
	import { publishPaywall } from './BackendServices/paywallServices'


	var changeKey = 0

	var publishLabel = "Publish"

	$: hasNavbar = $State.components.filter(c => c.type == "navBar").length > 0

	const addComponent = (name) => {

		if (hasNavbar && name == "navBar") {
			return
		}

		let c = {
			"type": name,
			"id": uuidv4(),
			"args": {
				"name": `${name}-${uuidv4().substring(0,4)}`
			},

		}

		let components = $State.components
		let inserted = false
		let insertionIndex = 0
		for (let i = 0; i < components.length; i++) {
			if (components[i].id == $State.activeElementId) {
				components.splice(i + 1, 0, c)
				inserted = true
				break
			}

			if (components[i].type == "fixedFooter") {
				insertionIndex = i
			}
		}

		if (!inserted) {
			components.splice(insertionIndex, 0, c)
		}

		$State.components = components
		addDefaultStyle($State)
		$State.activeElementId = c.id
		$State.components = adjustOrderForFixedItems($State.components)
		changeKey += 1
	}




	var showDebugger = false

	var pid = getProjectId()

	State.subscribe(v => {
		pid = getProjectId()
	})

	var publishedUrl = null

	const serialize = (obj) => {
		var str = [];
		for (var p in obj)
			if (obj.hasOwnProperty(p)) {
			str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
			}
		return str.join("&");
	}

	var launchURL = ""

	const gotPublishedUrl = (url) => {
		publishLabel = "Published!"

		setTimeout(() => {
			publishLabel = "Publish"
		}, 1500)

		publishedUrl = url

		let params = {
			"url": url,
			"name": `My Paywall on ${new Date().toISOString().slice(0, 10)}`,
			"identifier": uuidv4(),
			"paywallDismissal": "NORMAL",
			"presentationStyle": "FULLSCREEN",
			"backgroundColorHex": $State.page.args["page-container"].style["background-color"]
		}

		launchURL = `https://superwall.me/paywalls/new?${serialize(params)}`
		console.log(launchURL)

	}

	var showQROverride = false
	var hideQrCode = true

	$:{
		if (!hideQrCode) {
			startListeningForViewers()
		}

		if (!$ViewerState.isConnected) {
			showQROverride = false
		}

		if ($State.components.length == 0) {
			addComponent("fixedFooter")
		}

	}



</script>




<svelte:head>
	{#if $PaywallJSState.shouldLoad}
		<script async src="https://cdn.superwall.me/runtime/entrypoint.js"></script> 
	{/if}

    <link rel="preconnect" href="https://fonts.googleapis.com">
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>

	{#each Object.keys($State.fonts) as key}
		{#if $State.fonts[key].inUse} 
			<link async="true" href={`https://fonts.googleapis.com/css2?family=${$State.fonts[key].family.replaceAll(' ', '+')}:wght@${$State.fonts[key].variant}&display=swap`} rel="stylesheet">
			<link async="true" href={`https://fonts.googleapis.com/css?family=${$State.fonts[key].family.replaceAll(' ', '+')}:wght@${$State.fonts[key].variant}&display=swap`} rel="stylesheet">
		{/if}
	{/each }

</svelte:head>



<span style="{GlobalStyles}">

<div class="background-fix" id="backgroundFix">

</div>

<AppContainer > 
	<div class="navbar-container left" slot="navbar-left">
		{#if $State.previewMode}
			<Button action="{() => {showDebugger = !showDebugger}}">
				{ showDebugger ? "Close Debugger" : "Debug" }
			</Button>
		{/if}
	</div>

	<div class="navbar-container right" slot="navbar-right">

		<!-- <Button juicy={false} iconOnly={false} action="{() => { $State.previewMode = !$State.previewMode }}">
			{ $State.previewMode ? "Preview" : "Edit" }
		</Button> -->

		<a style="color: var(--primary-color); margin-right: 10px;" href="{window.origin}?project_id={pid}&sync=true"
		onclick="window.open(this.href,'targetWindow',
										`toolbar=no,
										 location=no,
										 status=no,
										 menubar=no,
										 scrollbars=no,
										 resizable=no,
										 width=375,
										 height=812`);
	  return false;">Preview</a>

		<Button juicy={true} action="{() => { publishLabel = "Publishing ..."; publishPaywall($State, gotPublishedUrl) }}">
			{publishLabel}
		</Button>
		{#if publishedUrl !== null}
			<div style="width: 10px;"></div>
			<a style="color: var(--primary-color);" href={publishedUrl} target="_blank"><Icon color="primary" height="18px" name="link"></Icon></a>
			<a style="color: var(--primary-color);" href={launchURL} target="_blank"><Icon color="primary" height="18px" name="doc.fill.badge.plus"></Icon></a>
		{/if}
	</div>

	<div class="container" slot="left">
		<div style="display: flex; align-items: center;">



		</div>

		{#if $State.previewMode}

			{#each allComponents as name}
				<div style="margin-bottom: 10px;">
					<Button action="{() => {addComponent(name)}}">
						<Icon height="11px" width="11px" margin="0px 10px 2px 0px" name="plus"></Icon> {name}
					</Button>
				</div>
			{/each}

			{#if showDebugger}
				<StateDebugger/>
			{/if}

			{#key pid}
				<div class="viewerStatusContainer" class:isViewerConnected={ !((!$ViewerState.isConnected || showQROverride) && !hideQrCode) } style="border: 1px solid rgba(255,255,255,0.1); border-radius: 10px; background-color: var(--light-bg-color); position: fixed; left: 20px; bottom: 20px; z-index: 0; display: flex; flex-direction: column; align-items: center;">
					{#if (!$ViewerState.isConnected || showQROverride) && !hideQrCode}
						<QrCode value="https://designer.superwall.me?project_id={pid}&sync=true"></QrCode>
						<!--  -->
						<div style="align-items: center; justify-content: center; display: flex; flex-direction: row; margin-top: 5px; ">
							<Button href="{window.origin}?project_id={pid}&sync=true" juicy={true} clear={true}>Open</Button>
							<div style="height: 24px; width: 1px; background-color: rgba(255,255,255,0.1); margin: 0px 16px;"></div>
							<Button juicy={true} clear={true} action={() => {hideQrCode = true}}>Hide</Button>
						</div>
					{:else}

						{#if hideQrCode}
							
								<!--  -->

								<Button clear={true} action={() => {hideQrCode = false}}>

									<div style="align-items: center; justify-content: center; display: flex; flex-direction: row;">
										<p style="margin-right: 16px;">Live Preview</p>
										<div style="height: 24px; width: 1px; background-color: rgba(255,255,255,0.1); margin-right: 16px;"></div>
										<Icon name="qrcode.viewfinder" color='primary' ></Icon>
									</div>

								</Button>
						{:else}
							<div style="align-items: center; justify-content: center; display: flex; flex-direction: row;">
								<!-- <Icon name="checkmark.circle" width="16px"></Icon> -->
								<p style="margin-right: 16px;">Viewer Connected</p>
								<div style="height: 24px; width: 1px; background-color: rgba(255,255,255,0.1); margin-right: 16px;"></div>
								<Button juicy={true} icon="arrow.clockwise.circle.fill" iconOnly={true} clear={true} action={() => {showQROverride = true}}></Button>
							</div>
						{/if}

					{/if}
				</div>
			{/key}	

		{/if}


		


	</div>
	<div class="container" slot="middle">

		{#key changeKey}
			<PaywallContainer/>
		{/key}

	</div>
	<div class="container editor-container" slot="right">
		<!-- {#if !$State.previewMode} -->

		<!-- {/if} -->
		<ComponentEditor/>

	</div>
</AppContainer>

</span>

<style>

	.background-fix {
		width: 100vw;
		height: 100vh;
		position: fixed;
		z-index: -1;
	}
	
	.viewerStatusContainer {
		max-width: 200px;
		width: 100%;
		padding: 10px;
		padding-bottom: 5px;
	}

	.isViewerConnected {
		width: auto;
		max-width: none;
		padding: 5px 20px;
	}

	.navbar-container {
		display: flex;
		flex-direction: row;
		align-items: center;
		padding: 0px 20px;
	}

	.navbar-container.left {
		justify-content: flex-start;
	}

	.navbar-container.right {
		justify-content: flex-end;
	}

	:global(*) {
		-webkit-touch-callout:none;
		-webkit-user-select:none
	}

	:global(body) {
		padding: 0;
		color: #A9B2C0;

		font-family: system-ui;
		background-color: #0D0F12;
	}

	:global(.hidden) {
		display: none;
	}

	:global(hr) {
		width: 100%;
		border-color: white !important;
		opacity: 0.1 !important;
	}


	:global(h1, h2, h3, h4, h5, h6, p) {
		padding: 0px; 
		margin: 0px;
	}

	.container {
		width: 100%;
		display: flex;
		flex-direction: column;
		flex-grow: 3.0;
	}
	
	:global(*::-webkit-scrollbar) {
		display: none;
	}

	:global(a, button, div) {
		-webkit-tap-highlight-color: transparent;
	}

	:global(*) {
		-ms-overflow-style: none;
		scrollbar-width: none;
	}

	:global(.flex) {
		display: flex;
	}

	:global(.flex.centered) {
		justify-content: center;
		align-items: center;
	}

	:global(.flex.stretch) {
		justify-content: stretch;
		align-items: stretch;
	}


	:global(.sw-button:active) {
		transform: scale(0.92);
		transition: transform 0.15s ease-in-out;
	}

	:global(.sw-button.sw-purchase-button:active) {
		transform: scale(0.92);
		transition: transform 0.15s ease-in-out;
	}

	:global(.sw-button) {
		opacity: 1.0;
		transform: scale(1.0);
		transition: transform 0.25s ease-in-out;
	}

	/* :global(.sw-button) {
		background-color: var(--secondary-button-bg-color);
		opacity: 0.7;
		transform: scale(0.92);
	} */

</style>
